import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-finite.js";
import "core-js/modules/es.number.to-fixed.js";
/**
 * Formats a Helix score for display.
 *
 * Averaged scores (overall scores, weekly per-skill scores, analytics averages) should be
 * passed the domain's configured `decimalPlaces` so they aren't flattened to whole numbers
 * on a small scale - a weekly average of 3.7 out of 5 is meaningfully different from 4.
 * Individual meeting skill scores are raw graded whole numbers, so they keep the default.
 *
 * Decimals are always shown to the configured precision rather than trimmed, so scores line
 * up with each other ("4.0/5" alongside "3.7/5").
 * @param score - The score to format
 * @param options - Formatting options
 * @param options.outOf - The scale the score is out of, shown as a "%" suffix when 100
 * @param options.decimalPlaces - How many decimal places to pad the score out to
 * @returns The formatted score, or undefined if there is no score to show
 */
export default function formatHelixScore(score) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$outOf = _ref.outOf,
    outOf = _ref$outOf === void 0 ? 100 : _ref$outOf,
    _ref$decimalPlaces = _ref.decimalPlaces,
    decimalPlaces = _ref$decimalPlaces === void 0 ? 0 : _ref$decimalPlaces;
  if (score === null || score === undefined || score === '') {
    return undefined;
  }
  var numericScore = Number(score);
  if (!Number.isFinite(numericScore)) {
    return undefined;
  }
  var value = numericScore.toFixed(decimalPlaces);
  return outOf === 100 ? "".concat(value, "%") : "".concat(value, "/").concat(outOf);
}